export enum TargetCheckType {
    Pra = 0,
    P1_2 = 2,
    P1_4 = 4,
    P1_5 = 5,
    Open = 6,
    Loops = 7,
    Future = 8 // combines Stalled P1_2 & Stalled Open
}

export enum TargetCheckTypeNew {
    HardToMatch = 0,
    Compatible = 10,
    Special = 20,
    Regular = 30,
    Open = 60,
    Loops = 70,
    Future = 80
}